module.exports = __webpack_public_path__ + "assets/successNote4-7c9e53.svg";